import { useStepperContext } from "app/contexts/stepper";
import { useInscripcionContext } from "../../inscripcion-context";
import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { toast } from "react-hot-toast";
import { useState } from "react";
import { correoElectronicoRegex } from "app/utils/regexps";

const initialState = {
  correo_electronico_direccion: "",
  correo_electronico_principal: false,
};

function CorreoElectronicoForm({ correo_electronico = initialState }) {
  const {
    addCorreoElectronico,
    updateCorreoElectronico,
    deleteCorreoElectronico,
  } = useInscripcionContext();

  const [state, setState] = useState(correo_electronico);
  const [isEditable] = useState(!!correo_electronico.correo_electronico_id);
  const [isEditing, setEditing] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditable && !isEditing) {
        return setEditing(true);
      } else if (!!isEditable && !!isEditing) {
        const isUpdated = updateCorreoElectronico({
          correo_electronico: state,
        });

        if (isUpdated) {
          setEditing(false);

          return toast.success("¡Dirección de correo electrónico actualizada!");
        }
      } else {
        const isAdded = addCorreoElectronico({ correo_electronico: state });

        if (isAdded) {
          setState(correo_electronico);

          return toast.success("¡Dirección de correo electrónico agregada!");
        }
      }
    } catch (error) {
      console.log(error.message);

      return toast.error(error.message);
    }
  }

  function handleReset() {
    if (!!isEditable && !isEditing) {
      const isDeleted = deleteCorreoElectronico({
        correo_electronico_id: correo_electronico.correo_electronico_id,
      });

      if (isDeleted) {
        return toast.success("¡Dirección de correo electrónico eliminada!");
      }
    } else if (!!isEditable && !!isEditing) {
      const isCanceled = window.confirm("¿Desea cancelar la edición?");

      if (isCanceled) {
        setState(correo_electronico);

        return setEditing(false);
      }
    } else {
      const isReseted = window.confirm("¿Desea reiniciar el formulario?");

      if (isReseted) {
        setState(correo_electronico);
      }
    }
  }

  return (
    <Paper
      component="form"
      className="animate__animated animate__slideInUp"
      onSubmit={handleSubmit}
      onReset={handleReset}
      variant="outlined"
    >
      <Grid container spacing={1} sx={{ padding: 2 }}>
        <Grid item xs={12}>
          <Typography variant="overline">
            <strong>{`${
              !!isEditable ? "Editar" : "Agregar"
            } dirección de correo electrónico`}</strong>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            type="text"
            label="Dirección de correo electrónico"
            value={state.correo_electronico_direccion}
            onChange={(e) =>
              setState((state) => ({
                ...state,
                correo_electronico_direccion: e.target.value,
              }))
            }
            inputProps={correoElectronicoRegex}
            size="small"
            fullWidth
            required
            disabled={!!isEditable && !isEditing}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormGroup>
            <FormControlLabel
              disabled={!!isEditable && !isEditing}
              control={
                <Checkbox
                  checked={state.correo_electronico_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      correo_electronico_principal: e.target.checked,
                    }))
                  }
                />
              }
              label="¿Es una dirección de correo electrónico principal?"
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12} md={6}>
          <Stack direction="row" justifyContent="end" spacing={1}>
            <Button
              type="submit"
              variant="contained"
              size="small"
              color={!!isEditable ? "warning" : "success"}
            >
              {!!isEditable && !isEditing
                ? "Editar"
                : !!isEditing
                ? "Actualizar"
                : "Agregar"}
            </Button>

            <Button
              type="reset"
              variant="outlined"
              size="small"
              color={!!isEditable && !isEditing ? "error" : "inherit"}
            >
              {!!isEditable && !isEditing
                ? "Eliminar"
                : !!isEditing
                ? "Cancelar"
                : "Reiniciar"}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
}

export function CorreosElectronicos() {
  const stepper = useStepperContext();
  const { empresa } = useInscripcionContext();

  function handleNext() {
    try {
      if (!empresa.correos_electronicos.length) {
        throw new Error(
          "¡Por favor, agregue al menos una dirección de correo electrónico!"
        );
      }

      return stepper.next();
    } catch (error) {
      return toast.error(error.message);
    }
  }

  return (
    <Stack spacing={2}>
      <Container maxWidth="sm">
        <Stack spacing={2}>
          {empresa.correos_electronicos.map((correo_electronico) => (
            <CorreoElectronicoForm
              key={correo_electronico.correo_electronico_id}
              correo_electronico={correo_electronico}
            />
          ))}

          <CorreoElectronicoForm />
        </Stack>
      </Container>

      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        spacing={1}
      >
        {!stepper.isFirstStep && (
          <Button variant="outlined" size="small" onClick={stepper.back}>
            Atrás
          </Button>
        )}

        <Button variant="contained" size="small" onClick={handleNext}>
          Siguiente
        </Button>
      </Stack>
    </Stack>
  );
}
